import React from 'react'
import { Link } from 'react-router-dom'
import { LAYOUT_ADMIN_NOTIFICATION_GROUP_SHOW } from '../../navigation'
import { configureField } from '../../../../core/utils/list'

export const basicColumns = (props) => {
  const { loading, filters, resize, hidden } = props

  if (loading) {
    return []
  }

  return [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
      width: 200,
      // eslint-disable-next-line react/display-name
      render: (name, record) => <Link to={LAYOUT_ADMIN_NOTIFICATION_GROUP_SHOW(record.id)}>{name}</Link>,
      ...configureField('ng.name', filters, resize, hidden, true, false, false, 200)
    },
    {
      title: 'TO/CC',
      dataIndex: 'cc',
      llipsis: true,
      ...configureField('ng.cc', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'CCO',
      dataIndex: 'cco',
      llipsis: true,
      ...configureField('ng.cco', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'Description',
      dataIndex: 'description',
      ellipsis: true,
      ...configureField('ng.description', filters, resize, hidden, true, false, true, 200)
    }
  ]
}
